module.exports = __webpack_public_path__ + "9bbc6e9602998a385c2ea13df56470fd.png";